// Special addon service code used to associate ev charging to a service
export const EVPARKING_SERVICE_CODE = "EV_CHARGING";
export const EVPARKING_UNITGROUP_CODE = "PARKING";

export const PROFILE_SECTIONS = {
  DETAILS: "details",
  PREFERENCES: "preferences",
  BOOKINGS: "bookings",
};

export const SIGN_IN_MODAL = {
  SIGN_IN: "signIn",
  SIGN_UP: "signUp",
  NONE: null,
};

export const CONSENT_STATUS = {
  OPTED_IN: "opted_in",
  IMPLICIT: "implied",
  NOT_CAPTURED: "not_captured",
  REVOKED: "revoked",
  NOT_FOUND: "not_found",
  REQUESTED: "requested",
};

export const CONSENT_TYPE = {
  OPT_IN: "explicit",
  IMPLICIT: "implicit",
};

export const STEPS = {
  PLAN_STAY: {
    INDEX: 1,
    STEPPER_TITLE: "Dates & guests",
    PAGE_TITLE: "Stay at Mollie's",
  },
  CHOOSE_ROOMS: {
    INDEX: 2,
    STEPPER_TITLE: "Choose rooms",
    PAGE_TITLE: "Choose your room",
  },
  CUSTOMIZE_STAY: {
    INDEX: 3,
    STEPPER_TITLE: "Customise stay",
    PAGE_TITLE: "Customise your stay",
  },
  PAYMENT: {
    INDEX: 4,
    STEPPER_TITLE: "Payment",
    PAGE_TITLE: "Payment",
  },
};

export const CHECKOUT_STEP_LABELS = {
  YOUR_DETAILS: "Your details",
  GUEST_DETAILS: "Guest Details",
  PERSONALISE_YOUR_STAY: "Personalise your stay",
  TERMS_AND_CONDITIONS: "Terms & Conditions",
  PAYMENT_DETAILS: "Payment Details",
};

export const PRIVATE_SPACES = {
  PRIVATE_DINING: {
    PAGE_TITLE: "Private Dining",
  },
};

// Hardcoded for now as mollies dont use sevenrooms shifts to control this
// Start and end times are inclusive
export const BREAKFAST_START_TIME = "06:00";
export const BREAKFAST_END_TIME = "11:00";

export const DINNER_START_TIME = "16:00";
export const DINNER_END_TIME = "22:00";

// Reservation addon types
export const ADDON_TYPE_REGULAR = "addons.regular-addon-details";
export const ADDON_TYPE_BASKET = "addons.basket-addon-details";
export const ADDON_TYPE_DATE = "addons.date-addon-details";

export const BOOKING_SOURCES = {
  DEFAULT: {
    id: null,
    showNavbar: true,
    showCookieConsent: true,
    authEnabled: true,
  },
  MOBILEAPP: {
    id: "mobileapp",
    showNavbar: true,
    showCookieConsent: true,
    authEnabled: true,
  },
  KIOSK: {
    id: "kiosk",
    showNavbar: false,
    showCookieConsent: true,
    authEnabled: false,
  },
  EMBEDDED: {
    id: "embedded",
    showNavbar: false,
    showCookieConsent: false,
    authEnabled: false,
  },
  SOHO: {
    id: "soho",
    showNavbar: true,
    showCookieConsent: true,
    authEnabled: false,
  },
};

export const BOOKING_THEMES = {
  DEFAULT: {
    id: null,
    name: "Mollies",
    description: "The default booking theme",
  },
  SOHO: {
    id: "soho",
    name: "Soho",
    description: "The Soho booking theme",
  },
};
